import { render, staticRenderFns } from "./BaseCompanyLogo.vue?vue&type=template&id=7207cdc7"
import script from "./BaseCompanyLogo.vue?vue&type=script&lang=js"
export * from "./BaseCompanyLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports